// OBT F3-C — Park OBT geçmişi (kapsam backend'de; ham park listesi indirilmez).
import { useCallback, useEffect, useRef, useState } from 'react';
import { fetchParkHistory } from '../reportApi';
import { normalizeObtError } from '../../obtErrors';

function isCanceled(error) {
  return (
    error?.code === 'ERR_CANCELED' ||
    error?.name === 'CanceledError' ||
    error?.name === 'AbortError'
  );
}

export function useParkReport(parkId, { enabled = true } = {}) {
  const [state, setState] = useState({ loading: false, error: null, history: null });
  const abortRef = useRef(null);

  const load = useCallback(async () => {
    if (!parkId || !enabled) {
      setState({ loading: false, error: null, history: null });
      return;
    }
    abortRef.current?.abort();
    const controller = new AbortController();
    abortRef.current = controller;
    setState({ loading: true, error: null, history: null });
    try {
      const history = await fetchParkHistory(parkId, { limit: 50, offset: 0 }, { signal: controller.signal });
      if (controller.signal.aborted) return;
      setState({ loading: false, error: null, history });
    } catch (error) {
      if (isCanceled(error) || controller.signal.aborted) return;
      setState({ loading: false, error: normalizeObtError(error), history: null });
    }
  }, [parkId, enabled]);

  useEffect(() => {
    load();
    return () => abortRef.current?.abort();
  }, [load]);

  return { ...state, reload: load };
}
